import type { MovieItem } from "@/types/movie";

interface MovieCardProps {
  item: MovieItem;
}

export default function MovieCard({ item }: MovieCardProps) {
  return (
    <article className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors duration-300 hover:border-primary-300">
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-secondary-200">
        <img
          src={item.poster}
          alt={`${item.title} 海报`}
          title={`${item.title} ${item.genre}影视资源`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 rounded-md bg-accent-500/95 px-2 py-0.5 text-xs font-medium text-background-50">
          {item.tag}
        </span>
        <span className="absolute right-2 top-2 flex items-center gap-1 rounded-md bg-background-50/95 px-2 py-0.5 text-xs font-bold text-accent-700">
          <i className="ri-star-fill text-[11px] text-primary-500"></i>
          {item.rating.toFixed(1)}
        </span>
      </div>
      <div className="flex flex-1 flex-col gap-2 p-4">
        <h3 className="truncate text-base font-semibold text-foreground-950" title={item.title}>
          {item.title}
        </h3>
        <div className="flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-foreground-600">
          <span>{item.year}</span>
          <span className="text-background-300">·</span>
          <span>{item.region}</span>
          <span className="text-background-300">·</span>
          <span>{item.genre}</span>
        </div>
        <p className="line-clamp-2 text-sm leading-relaxed text-foreground-600">{item.summary}</p>
        <div className="mt-auto flex items-center justify-between border-t border-background-200 pt-3">
          <span className="text-xs text-foreground-500">{item.meta}</span>
          <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs font-medium text-secondary-900">
            {item.category}
          </span>
        </div>
      </div>
    </article>
  );
}